module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ebd6f63.woff";